module.exports = __webpack_public_path__ + "img/nav-right-with-contact-black-ford.2de82ebd.png";